import { Component, Inject, Input } from '@angular/core';
import { WINDOW } from '@innogy/utils-dom';

import type { ShareButton } from './share-buttons.model';
@Component({
  selector: 'wl-share-buttons',
  templateUrl: './share-buttons.component.html',
  styleUrls: [
    './share-buttons.component.essent.scss',
    './share-buttons.component.ed.scss',
  ],
})
export class ShareButtonsComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() items?: ShareButton[];

  private readonly windowOptions =
    'menubar=no,location=yes,resizable=yes,scrollbars=no,status=no';

  constructor(@Inject(WINDOW) private readonly windowRef: Window | null) {}

  public openShare(url?: string) {
    if (url != null && this.windowRef) {
      this.windowRef.open(url, this.windowOptions);
    }
    return false;
  }
}
